import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { Sort } from "@angular/material/sort";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
//import { ConfirmationDialog } from "src/app/share/dialog/confirmation-dialog/confirmation.dialog";
import { CommonSelectionInterface } from "src/app/share/interface/common.interface";
import { AlertService } from "src/app/share/service/alert.service";
import { PersonalProtectionDataService } from "src/app/share/data-service/personal-perotection/personal-protection.data.service";
import { CelcomdigiPolicyListing } from "src/app/share/interface/personal-protection/pp-celcomdigi.interface";
import { PolicyStatus } from "../../../share/constants/celcomdigi/policy-status";
import { ClaimStatus } from "../../../share/constants/celcomdigi/claim-status";
import { CancelPolicyComponent } from "../cancel-policy/cancel-policy.component";

@Component({
  selector: "app-celcomdigi",
  templateUrl: "./celcomdigi.component.html",
  styleUrls: ["./celcomdigi.component.scss"]
})
export class CelcomdigiComponent implements OnInit, AfterViewInit {
  statusList: CommonSelectionInterface[] = [];
  claimStatusList: CommonSelectionInterface[] = [];
  policyStatusList: CommonSelectionInterface[] = [];

  filterStatusList: CommonSelectionInterface[] = [];
  filterClaimStatusList: CommonSelectionInterface[] = [];
  filterPolicyStatusList: CommonSelectionInterface[] = [];

  selectedStatusList: string[] = [];
  selectedClaimStatusList: string[] = [];
  selectedPolicyStatusList: string[] = [];

  startDate: Date;
  endDate: Date;

  minFilterEndDate: Date;

  filterSelected: "today" | "week" | "month" | "year" | "all" | "custom" =
    "all";
  lastFilterSelected: "today" | "week" | "month" | "year" | "all" | "custom" =
    "all";

  searchText: string;
  searchChange: Subject<void> = new Subject<void>();

  sortIndex: number = 0;
  sortDirection: "asc" | "desc" = "desc";

  yesterdayCount: number = 0;
  isYesterdayCountLoading: boolean = true;
  before6Count: number = 0;
  after6Count: number = 0;

  dataSource: CelcomdigiPolicyListing[] = [];

  isLoading = false;

  displayedColumns: string[] = [
    "createdDate",
    "productType",
    "policyRefNo",
    "mobileNo",
    "status",
    "claimStatus",
    "action"
  ];

  status: string[] = [];
  limit: number = 50;
  offset: number = 1;
  length = 0;
  selected: any;

  @ViewChild("paginator") paginator;

  constructor(
    private dialog: MatDialog,
    private alertService: AlertService,
    private personalprotectionDataService: PersonalProtectionDataService,
    private ngxSpinnerService: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getListSelection();

    this.searchChange.pipe(debounceTime(500)).subscribe(() => {
      this.filter();
    });
  }

  ngAfterViewInit(): void {
    this.resumeFilterQueryParams();
    this.getData();
  }

  //#region policy status filter
  filterPolicyStatusSelection(searchValue: string = null) {
    if (searchValue) {
      let txt = searchValue.toLowerCase().trim();
      this.filterPolicyStatusList = this.policyStatusList.filter((x) =>
        x.name.toLowerCase().includes(txt)
      );
    } else {
      this.filterPolicyStatusList = Object.assign([], this.policyStatusList);
    }
  }

  isSelectedAllPolicyStatus() {
    return this.selectedPolicyStatusList.length == this.policyStatusList.length;
  }

  isIndeterminatePolicyStatus() {
    if (this.isSelectedAllPolicyStatus()) return false;
    return this.selectedPolicyStatusList.length > 0;
  }

  toggleSelectAllPolicyStatus(val: boolean, hasFilter: boolean = true) {
    this.selectedPolicyStatusList = [];
    if (val) {
      this.selectedPolicyStatusList = this.policyStatusList.map((y) => y.id);
      if (hasFilter) {
        this.filter();
      }
    } else {
      this.dataSource = [];
      this.length = 0;
    }
  }

  getPolicyStatusDisplay() {
    if (this.selectedPolicyStatusList.length == 1)
      return this.policyStatusList.find(
        (x) => x.id == this.selectedPolicyStatusList[0]
      ).name;
    else if (this.isSelectedAllPolicyStatus()) return "All policy status";
    else
      return `${this.selectedPolicyStatusList.length} policy status selected`;
  }

  resetPolicyStatus() {
    event.stopImmediatePropagation();
    this.toggleSelectAllPolicyStatus(true);
  }

  //#region Claim status filter
  filterClaimStatusSelection(searchValue: string = null) {
    if (searchValue) {
      let txt = searchValue.toLowerCase().trim();
      this.filterClaimStatusList = this.claimStatusList.filter((x) =>
        x.name.toLowerCase().includes(txt)
      );
    } else {
      this.filterClaimStatusList = Object.assign([], this.claimStatusList);
    }
  }

  isSelectedAllClaimStatus() {
    return this.selectedClaimStatusList.length == this.claimStatusList.length;
  }

  isIndeterminateClaimStatus() {
    if (this.isSelectedAllClaimStatus()) return false;
    return this.selectedClaimStatusList.length > 0;
  }

  toggleSelectAllClaimStatus(val: boolean, hasFilter: boolean = true) {
    this.selectedClaimStatusList = [];
    if (val) {
      this.selectedClaimStatusList = this.claimStatusList.map((y) => y.id);
    } else {
      // this.length = 0;
      this.selectedClaimStatusList = [];
    }
    if (hasFilter) {
      this.filter();
    }
  }

  getClaimStatusDisplay() {
    if (this.selectedClaimStatusList.length == 1)
      return this.claimStatusList.find(
        (x) => x.id == this.selectedClaimStatusList[0]
      ).name;
    else if (this.isSelectedAllClaimStatus()) return "All Claim Status";
    else return `${this.selectedClaimStatusList.length} claim status selected`;
  }

  //#endregion

  resetClaimStatus() {
    event.stopImmediatePropagation();
    this.toggleSelectAllClaimStatus(false);
  }

  //#region Date filter
  setTodayDate(hasFilter: boolean = true) {
    this.startDate = new Date();
    this.endDate = new Date();
    this.setDefaultTimeRange();
    if (hasFilter) {
      this.filter();
    }
  }

  setCurrentWeekDate() {
    this.startDate = moment().startOf("week").toDate();
    this.endDate = moment().endOf("week").toDate();
    this.setDefaultTimeRange();
    this.filter();
  }

  setCurrentMonthDate() {
    this.startDate = moment().startOf("month").toDate();
    this.endDate = moment().endOf("month").toDate();
    this.setDefaultTimeRange();
    this.filter();
  }

  setCurrentYearDate() {
    this.startDate = moment().startOf("year").toDate();
    this.endDate = moment().endOf("year").toDate();
    this.setDefaultTimeRange();
    this.filter();
  }

  resetDate() {
    this.startDate = null;
    this.endDate = null;
    this.filter();
  }

  //#endregion

  onStartDateSelected(e) {
    this.startDate = e.target.value;
  }

  onEndDateSelected(e) {
    this.endDate = new Date(e.target.value.setHours(23, 59, 59, 999));
  }

  onDateRangePickerClosed() {
    if (this.startDate && this.endDate) {
      this.filter();
    } else if (this.startDate == null) {
      this.startDateClose();
    } else if (this.endDate == null) {
      this.endDateClose();
    }
  }

  startDateOpen() {
    this.startDate = null;
    this.endDate = null;
  }

  startDateClose() {
    if (this.startDate == null) {
      this.filterSelected = this.lastFilterSelected;
      switch (this.filterSelected) {
        case "today":
          this.setTodayDate();
          break;
        case "week":
          this.setCurrentWeekDate();
          break;
        case "month":
          this.setCurrentMonthDate();
          break;
        case "year":
          this.setCurrentYearDate();
          break;
        case "all":
          this.resetDate();
          break;
      }
    }
  }

  endDateClose() {
    if (this.endDate == null) {
      this.endDate = this.startDate;
    }
    this.filter();
  }

  resetDateFilter() {
    event.stopImmediatePropagation();
    this.resetDate();
    this.filterSelected = "all";
    this.lastFilterSelected = this.filterSelected;
  }

  sortChange(sortState: Sort) {
    this.sortDirection = null;
    this.sortIndex = -1;
    if (sortState.direction) {
      this.sortDirection = sortState.direction;
      this.sortIndex = this.displayedColumns.findIndex(
        (x) => x == sortState.active
      );
    }
    if (this.dataSource.length == 0) return;

    this.getData();
  }

  resetTextFilter() {
    event.stopImmediatePropagation();
    this.searchText = null;
    this.filter();
  }

  pageChange(e: PageEvent) {
    this.offset = e.pageIndex + 1;
    this.limit = e.pageSize;
    this.getData();
  }

  filter() {
    this.offset = 1;
    this.getData();
  }

  //#endregion

  /*exportPolicies() {
    if (this.startDate && this.endDate) {
      let startDateFormatted = moment(this.startDate).format("DD MMM yyyy");
      let endDateFormatted = moment(this.endDate).format("DD MMM yyyy");
      let dialogRef = this.dialog.open(ConfirmationDialog, {
        data: {
          title: "Download policies data",
          content: "You selected data for",
          boldContent: `${startDateFormatted} - ${endDateFormatted}`,
          btnColor: "primary",
          cancelBtnText: "Cancel",
          okBtnText: "Export",
          hideQuestionMark: true
        }
      });
 
      dialogRef.componentInstance.confirm.subscribe((x) => {
        this.ngxSpinnerService.show();
        // TODO: Refactor to use maxis API
        this.ecommerceDataService
          .getMaxisPolicyListingExcel(
            this.limit,
            this.offset,
            this.searchText,
            this.sortIndex,
            this.sortDirection,
            this.selectedClaimStatusList,
            this.selectedPolicyStatusList,
            [],
            this.startDate,
            this.endDate
          )
          .subscribe({
            next: (x: any) => {
              this.isLoading = false;
              this.alertService.openSnackBar("Downloading file ...");
              this.ngxSpinnerService.hide();
              let binaryData = [];
              binaryData.push(x);
              let downloadLink = document.createElement("a");
              downloadLink.href = window.URL.createObjectURL(
                new Blob(binaryData, {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                })
              );
 
              downloadLink.setAttribute("download", "EcommercePolicies.xlsx");
 
              document.body.appendChild(downloadLink);
              downloadLink.click();
            },
            error: (x) => {
              this.isLoading = false;
              this.alertService.openSnackBar("Error exporting data");
              this.ngxSpinnerService.hide();
            }
          });
      });
    } else {
      this.dialog.open(ConfirmationDialog, {
        data: {
          title: "Can't download policies data",
          content: "Please select a date filter before exporting policies data",
          btnColor: "primary",
          cancelBtnText: "Cancel",
          okBtnText: "Ok",
          hideQuestionMark: true
        }
      });
    }
  }*/

  viewClaims(id: string) {
    this.router.navigate(["../celcomdigi/details"], {
      relativeTo: this.route,
      queryParams: { id: id }
    });
  }

  deactivate(data: any) {
    let dialogRef = this.dialog.open(CancelPolicyComponent, {
      data: {
        id: data.policyId,
        itemPolicyNo: data?.itemPolicyNo
      }
    });
 
    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.getData();
      }
    });
  }

  getPolicyStatusCss(policyStatus: string): string {
    switch (policyStatus) {
      case PolicyStatus.Active:
        return "green";
      case PolicyStatus.Expired:
      case PolicyStatus.Cancelled:
        return "red";
      case PolicyStatus.Refunded:
      case PolicyStatus.Lapsed:
      default:
        return "orange";
    }
  }

  getClaimStatusCss(claimStatus: string): string {
    switch (claimStatus) {
      case ClaimStatus.New:
        return "grey";
      case ClaimStatus.Approved:
        return "green";
      case ClaimStatus.Rejected:
        return "red";
      default:
        return "orange";
    }
  }

  private getData(): void {
    this.isLoading = true;
    this.cdr.detectChanges();
    this.dataSource = [];
    this.length = 0;

    this.personalprotectionDataService
      .getCelcomdigiPolicyListing(
        this.limit,
        this.offset,
        this.searchText,
        this.sortIndex,
        this.sortDirection,
        this.startDate,
        this.endDate,
        this.selectedPolicyStatusList,
        this.selectedClaimStatusList
      )
      .subscribe({
        next: (x: { count: number; data: CelcomdigiPolicyListing[] }) => {
          this.isLoading = false;
          this.dataSource = x.data;
          this.length = x.count;
          this.applyFilterToUrl();
        },
        error: (err) => {
          this.isLoading = false;
          this.alertService.openSnackBar(err.error);
        }
      });
  }

  private getListSelection(): void {
    this.claimStatusList = this.personalprotectionDataService.getCelcomdigiClaimStatusList();
    this.policyStatusList = this.personalprotectionDataService.getCelcomdigiPolicyStatusList();

    this.filterClaimStatusSelection();
    this.filterPolicyStatusSelection();
    this.toggleSelectAllClaimStatus(false, false);
    this.toggleSelectAllPolicyStatus(true, false);
  }

  private resumeFilterQueryParams(): void {
    let queryParams = this.route.snapshot.queryParams;

    // Setting for Claim status filter
    if (queryParams?.claimStatus) {
      let claimStatusQuery = queryParams.claimStatus;
      if (
        typeof claimStatusQuery === "string" ||
        claimStatusQuery instanceof String
      ) {
        claimStatusQuery = [queryParams.claimStatus];
      }
      this.selectedClaimStatusList = queryParams?.claimStatus?.length
        ? claimStatusQuery
        : this.claimStatusList.map((x) => x.id);
    }

    // Setting for Policy status filter
    if (queryParams?.policyStatus) {
      let policyStatusQuery = queryParams.policyStatus;
      if (
        typeof policyStatusQuery === "string" ||
        policyStatusQuery instanceof String
      ) {
        policyStatusQuery = [queryParams.policyStatus];
      }
      this.selectedPolicyStatusList = queryParams?.policyStatus?.length
        ? policyStatusQuery
        : this.policyStatusList.map((x) => x.id);
    }

    //Setting for date filter
    if (queryParams?.by) {
      this.filterSelected = queryParams.by;
      this.startDateClose();
    }

    //Setting for page offset filter
    if (queryParams?.offset) {
      this.offset = queryParams.offset || 1;
      this.paginator.pageIndex = this.offset - 1;
    }

    if (queryParams?.sortIndex !== 0) {
      this.sortIndex = queryParams.sortIndex;
    }

    if (queryParams?.sortDirection) {
      this.sortDirection = queryParams.sortDirection;
    }

    //Setting for search filter
    this.searchText = queryParams?.filter;
  }

  private applyFilterToUrl() {
    const claimStatusAreFiltered =
      this.selectedClaimStatusList.length > 0 &&
      this.claimStatusList.length !== this.selectedClaimStatusList.length;
    const policyStatusAreFiltered =
      this.selectedPolicyStatusList.length > 0 &&
      this.policyStatusList.length !== this.selectedPolicyStatusList.length;

    if (
      this.searchText ||
      claimStatusAreFiltered ||
      policyStatusAreFiltered ||
      this.sortIndex !== -1 ||
      this.sortDirection
    ) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          filter: this.searchText?.length > 0 ? this.searchText : null,
          claimStatus: claimStatusAreFiltered
            ? this.selectedClaimStatusList
            : null,
          policyStatus: policyStatusAreFiltered
            ? this.selectedPolicyStatusList
            : null,
          sortIndex: this.sortIndex !== 0 ? this.sortIndex : null,
          sortDirection:
            this.sortDirection !== "asc" ? this.sortDirection : null,
          by: this.filterSelected !== "all" ? this.filterSelected : null,
          offset: this.offset !== 1 ? this.offset : null
        },
        queryParamsHandling: "merge",
        replaceUrl: true
      });
    } else {
      this.router.navigate([]);
    }
  }

  private setDefaultTimeRange() {
    this.startDate.setHours(0, 0, 0, 0);
    this.endDate.setHours(23, 59, 59, 999);
  }
}
